import { render, staticRenderFns } from "./CallCenters.vue?vue&type=template&id=75db670c&scoped=true"
import script from "./CallCenters.vue?vue&type=script&lang=js"
export * from "./CallCenters.vue?vue&type=script&lang=js"
import style0 from "./CallCenters.vue?vue&type=style&index=0&id=75db670c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75db670c",
  null
  
)

export default component.exports